// This file automatically generated by skymarshal.
// DO NOT MODIFY BY HAND!!!!
//
// From Source File: vehicle/planner/lcmtypes/movement.lcm

import { float } from "@skydio/lcm/src/types";
import { int16_t } from "@skydio/lcm/src/types";
import { int64_t } from "@skydio/lcm/src/types";
import { Vector3d } from "../eigen_lcm/Vector3d";
import { gimbal_orientation_mode_t } from "../planner/gimbal_orientation_mode_t";
import { gimbal_roll_command_t } from "../planner/gimbal_roll_command_t";
import { movement_command_source_t } from "../planner/movement_command_source_t";
import { spatial_waypoints_command_t } from "../planner/spatial_waypoints_command_t";

import Long from "long";
import Decoder from "@skydio/lcm/src/decoder";
import Encoder from "@skydio/lcm/src/encoder";
import LcmMsg from "@skydio/lcm/src/lcm";
import ReflectionMeta from "@skydio/lcm/src/reflection";

export class movement_t extends LcmMsg {

  private static _hash = Long.fromString("10333375100696332957", true);
  private static _packed_fingerprint?: Long;

  /** @internal */
  public static override _get_packed_fingerprint(): Long {
    if (movement_t._packed_fingerprint === undefined) {
      movement_t._packed_fingerprint = movement_t._get_hash_recursive([]);
    }
    return movement_t._packed_fingerprint;
  }

  /** @internal */
  public static override _get_hash_recursive(parents: any[]): Long {
    if (parents.indexOf(movement_t) > -1) {
      return Long.fromNumber(0, true);
    }
    const new_parents = parents.concat([movement_t]);
    let tmp_hash = movement_t._hash;
    tmp_hash = tmp_hash.add(movement_command_source_t._get_hash_recursive(new_parents));
    tmp_hash = tmp_hash.add(Vector3d._get_hash_recursive(new_parents));
    tmp_hash = tmp_hash.add(Vector3d._get_hash_recursive(new_parents));
    tmp_hash = tmp_hash.add(gimbal_roll_command_t._get_hash_recursive(new_parents));
    tmp_hash = tmp_hash.add(spatial_waypoints_command_t._get_hash_recursive(new_parents));
    tmp_hash = tmp_hash.add(gimbal_orientation_mode_t._get_hash_recursive(new_parents));
    return tmp_hash.shl(1).add(tmp_hash.shru(63));
  }

  /** @internal */
  public static override _reflection_meta: ReflectionMeta = {
    utime: { kind: "primitive", type: Number, typeStr: "int64_t" },
    source: { kind: "struct", type: movement_command_source_t, typeStr: "movement_command_source_t" },
    source_utime: { kind: "primitive", type: Number, typeStr: "int64_t" },
    position: { kind: "struct", type: Vector3d, typeStr: "Vector3d" },
    position_aggressiveness: { kind: "primitive", type: Number, typeStr: "float" },
    velocity: { kind: "struct", type: Vector3d, typeStr: "Vector3d" },
    velocity_aggressiveness: { kind: "primitive", type: Number, typeStr: "float" },
    max_speed: { kind: "primitive", type: Number, typeStr: "float" },
    pos_vel_frame: { kind: "primitive", type: Number, typeStr: "int16_t" },
    heading: { kind: "primitive", type: Number, typeStr: "float" },
    heading_smoothness: { kind: "primitive", type: Number, typeStr: "float" },
    heading_aggressiveness: { kind: "primitive", type: Number, typeStr: "float" },
    heading_rate: { kind: "primitive", type: Number, typeStr: "float" },
    heading_rate_aggressiveness: { kind: "primitive", type: Number, typeStr: "float" },
    max_heading_rate: { kind: "primitive", type: Number, typeStr: "float" },
    gimbal_pitch: { kind: "primitive", type: Number, typeStr: "float" },
    gimbal_pitch_smoothness: { kind: "primitive", type: Number, typeStr: "float" },
    gimbal_pitch_aggressiveness: { kind: "primitive", type: Number, typeStr: "float" },
    gimbal_pitch_rate: { kind: "primitive", type: Number, typeStr: "float" },
    gimbal_pitch_rate_aggressiveness: { kind: "primitive", type: Number, typeStr: "float" },
    max_gimbal_pitch_rate: { kind: "primitive", type: Number, typeStr: "float" },
    gimbal_roll_command: { kind: "struct", type: gimbal_roll_command_t, typeStr: "gimbal_roll_command_t" },
    enforce_lookat_smoothness: { kind: "primitive", type: Boolean, typeStr: "boolean" },
    height: { kind: "primitive", type: Number, typeStr: "float" },
    height_aggressiveness: { kind: "primitive", type: Number, typeStr: "float" },
    spatial_waypoints_enable: { kind: "primitive", type: Boolean, typeStr: "boolean" },
    spatial_waypoints_command: { kind: "struct", type: spatial_waypoints_command_t, typeStr: "spatial_waypoints_command_t" },
    override_precision_flight: { kind: "primitive", type: Boolean, typeStr: "boolean" },
    gimbal_orientation_mode: { kind: "struct", type: gimbal_orientation_mode_t, typeStr: "gimbal_orientation_mode_t" },
  };

  public static UNSPECIFIED: int16_t = 0;
  public static NAV: int16_t = 1;
  public static VEHICLE_YAW: int16_t = 2;
  public static SUBJECT: int16_t = 3;
  public static IMAGE: int16_t = 4;
  public utime: int64_t;
  public source: movement_command_source_t;
  public source_utime: int64_t;
  public position: Vector3d;
  public position_aggressiveness: float;
  public velocity: Vector3d;
  public velocity_aggressiveness: float;
  public max_speed: float;
  public pos_vel_frame: int16_t;
  public heading: float;
  public heading_smoothness: float;
  public heading_aggressiveness: float;
  public heading_rate: float;
  public heading_rate_aggressiveness: float;
  public max_heading_rate: float;
  public gimbal_pitch: float;
  public gimbal_pitch_smoothness: float;
  public gimbal_pitch_aggressiveness: float;
  public gimbal_pitch_rate: float;
  public gimbal_pitch_rate_aggressiveness: float;
  public max_gimbal_pitch_rate: float;
  public gimbal_roll_command: gimbal_roll_command_t;
  public enforce_lookat_smoothness: boolean;
  public height: float;
  public height_aggressiveness: float;
  public spatial_waypoints_enable: boolean;
  public spatial_waypoints_command: spatial_waypoints_command_t;
  public override_precision_flight: boolean;
  public gimbal_orientation_mode: gimbal_orientation_mode_t;

  public override decode(byte_array: Uint8Array): movement_t {
    const decoder = new Decoder(new DataView(
      byte_array.buffer, byte_array.byteOffset, byte_array.byteLength
    ));
    const hash = decoder.decode_hash();
    if (!hash.equals(movement_t._get_packed_fingerprint())) {
      console.error("Hash mismatch", hash, movement_t._get_packed_fingerprint());
      throw new Error("Hash mismatch!");
    }
    this.decode_one(decoder);
    return this;
  }

  public override decode_one(decoder: Decoder): movement_t {
    this.utime = decoder.decode_int64_t();
    this.source = new movement_command_source_t().decode_one(decoder);
    this.source_utime = decoder.decode_int64_t();
    this.position = new Vector3d().decode_one(decoder);
    this.position_aggressiveness = decoder.decode_float();
    this.velocity = new Vector3d().decode_one(decoder);
    this.velocity_aggressiveness = decoder.decode_float();
    this.max_speed = decoder.decode_float();
    this.pos_vel_frame = decoder.decode_int16_t();
    this.heading = decoder.decode_float();
    this.heading_smoothness = decoder.decode_float();
    this.heading_aggressiveness = decoder.decode_float();
    this.heading_rate = decoder.decode_float();
    this.heading_rate_aggressiveness = decoder.decode_float();
    this.max_heading_rate = decoder.decode_float();
    this.gimbal_pitch = decoder.decode_float();
    this.gimbal_pitch_smoothness = decoder.decode_float();
    this.gimbal_pitch_aggressiveness = decoder.decode_float();
    this.gimbal_pitch_rate = decoder.decode_float();
    this.gimbal_pitch_rate_aggressiveness = decoder.decode_float();
    this.max_gimbal_pitch_rate = decoder.decode_float();
    this.gimbal_roll_command = new gimbal_roll_command_t().decode_one(decoder);
    this.enforce_lookat_smoothness = decoder.decode_boolean();
    this.height = decoder.decode_float();
    this.height_aggressiveness = decoder.decode_float();
    this.spatial_waypoints_enable = decoder.decode_boolean();
    this.spatial_waypoints_command = new spatial_waypoints_command_t().decode_one(decoder);
    this.override_precision_flight = decoder.decode_boolean();
    this.gimbal_orientation_mode = new gimbal_orientation_mode_t().decode_one(decoder);
    return this;
  }

  /** @internal */
  public _get_encoded_size(): number {
    let total_size = 0;
    total_size += 8;
    total_size += this.source._get_encoded_size();
    total_size += 8;
    total_size += this.position._get_encoded_size();
    total_size += 4;
    total_size += this.velocity._get_encoded_size();
    total_size += 4;
    total_size += 4;
    total_size += 2;
    total_size += 4;
    total_size += 4;
    total_size += 4;
    total_size += 4;
    total_size += 4;
    total_size += 4;
    total_size += 4;
    total_size += 4;
    total_size += 4;
    total_size += 4;
    total_size += 4;
    total_size += 4;
    total_size += this.gimbal_roll_command._get_encoded_size();
    total_size += 1;
    total_size += 4;
    total_size += 4;
    total_size += 1;
    total_size += this.spatial_waypoints_command._get_encoded_size();
    total_size += 1;
    total_size += this.gimbal_orientation_mode._get_encoded_size();
    return total_size;
  }

  public override encode(): ArrayBufferLike {
    const encoder = new Encoder(8 + this._get_encoded_size()); // hash + rest
    encoder.encode_hash(movement_t._get_packed_fingerprint());
    this.encode_one(encoder);

    return encoder.view.buffer;
  }

  public override encode_one(encoder: Encoder): void {
    encoder.encode_int64_t(this.utime);
    this.source.encode_one(encoder);
    encoder.encode_int64_t(this.source_utime);
    this.position.encode_one(encoder);
    encoder.encode_float(this.position_aggressiveness);
    this.velocity.encode_one(encoder);
    encoder.encode_float(this.velocity_aggressiveness);
    encoder.encode_float(this.max_speed);
    encoder.encode_int16_t(this.pos_vel_frame);
    encoder.encode_float(this.heading);
    encoder.encode_float(this.heading_smoothness);
    encoder.encode_float(this.heading_aggressiveness);
    encoder.encode_float(this.heading_rate);
    encoder.encode_float(this.heading_rate_aggressiveness);
    encoder.encode_float(this.max_heading_rate);
    encoder.encode_float(this.gimbal_pitch);
    encoder.encode_float(this.gimbal_pitch_smoothness);
    encoder.encode_float(this.gimbal_pitch_aggressiveness);
    encoder.encode_float(this.gimbal_pitch_rate);
    encoder.encode_float(this.gimbal_pitch_rate_aggressiveness);
    encoder.encode_float(this.max_gimbal_pitch_rate);
    this.gimbal_roll_command.encode_one(encoder);
    encoder.encode_boolean(this.enforce_lookat_smoothness);
    encoder.encode_float(this.height);
    encoder.encode_float(this.height_aggressiveness);
    encoder.encode_boolean(this.spatial_waypoints_enable);
    this.spatial_waypoints_command.encode_one(encoder);
    encoder.encode_boolean(this.override_precision_flight);
    this.gimbal_orientation_mode.encode_one(encoder);
  }

  constructor(init?: {utime?: int64_t, source?: movement_command_source_t, source_utime?: int64_t, position?: Vector3d, position_aggressiveness?: float, velocity?: Vector3d, velocity_aggressiveness?: float, max_speed?: float, pos_vel_frame?: int16_t, heading?: float, heading_smoothness?: float, heading_aggressiveness?: float, heading_rate?: float, heading_rate_aggressiveness?: float, max_heading_rate?: float, gimbal_pitch?: float, gimbal_pitch_smoothness?: float, gimbal_pitch_aggressiveness?: float, gimbal_pitch_rate?: float, gimbal_pitch_rate_aggressiveness?: float, max_gimbal_pitch_rate?: float, gimbal_roll_command?: gimbal_roll_command_t, enforce_lookat_smoothness?: boolean, height?: float, height_aggressiveness?: float, spatial_waypoints_enable?: boolean, spatial_waypoints_command?: spatial_waypoints_command_t, override_precision_flight?: boolean, gimbal_orientation_mode?: gimbal_orientation_mode_t }) {
    super();
    this.utime = 0;
    this.source = new movement_command_source_t();
    this.source_utime = 0;
    this.position = new Vector3d();
    this.position_aggressiveness = 0.0;
    this.velocity = new Vector3d();
    this.velocity_aggressiveness = 0.0;
    this.max_speed = 0.0;
    this.pos_vel_frame = 0;
    this.heading = 0.0;
    this.heading_smoothness = 0.0;
    this.heading_aggressiveness = 0.0;
    this.heading_rate = 0.0;
    this.heading_rate_aggressiveness = 0.0;
    this.max_heading_rate = 0.0;
    this.gimbal_pitch = 0.0;
    this.gimbal_pitch_smoothness = 0.0;
    this.gimbal_pitch_aggressiveness = 0.0;
    this.gimbal_pitch_rate = 0.0;
    this.gimbal_pitch_rate_aggressiveness = 0.0;
    this.max_gimbal_pitch_rate = 0.0;
    this.gimbal_roll_command = new gimbal_roll_command_t();
    this.enforce_lookat_smoothness = false;
    this.height = 0.0;
    this.height_aggressiveness = 0.0;
    this.spatial_waypoints_enable = false;
    this.spatial_waypoints_command = new spatial_waypoints_command_t();
    this.override_precision_flight = false;
    this.gimbal_orientation_mode = new gimbal_orientation_mode_t();

    // optionally override default values
    if (!init) {
      return;
    }
    this.utime = init.utime || this.utime;
    this.source = init.source || this.source;
    this.source_utime = init.source_utime || this.source_utime;
    this.position = init.position || this.position;
    this.position_aggressiveness = init.position_aggressiveness || this.position_aggressiveness;
    this.velocity = init.velocity || this.velocity;
    this.velocity_aggressiveness = init.velocity_aggressiveness || this.velocity_aggressiveness;
    this.max_speed = init.max_speed || this.max_speed;
    this.pos_vel_frame = init.pos_vel_frame || this.pos_vel_frame;
    this.heading = init.heading || this.heading;
    this.heading_smoothness = init.heading_smoothness || this.heading_smoothness;
    this.heading_aggressiveness = init.heading_aggressiveness || this.heading_aggressiveness;
    this.heading_rate = init.heading_rate || this.heading_rate;
    this.heading_rate_aggressiveness = init.heading_rate_aggressiveness || this.heading_rate_aggressiveness;
    this.max_heading_rate = init.max_heading_rate || this.max_heading_rate;
    this.gimbal_pitch = init.gimbal_pitch || this.gimbal_pitch;
    this.gimbal_pitch_smoothness = init.gimbal_pitch_smoothness || this.gimbal_pitch_smoothness;
    this.gimbal_pitch_aggressiveness = init.gimbal_pitch_aggressiveness || this.gimbal_pitch_aggressiveness;
    this.gimbal_pitch_rate = init.gimbal_pitch_rate || this.gimbal_pitch_rate;
    this.gimbal_pitch_rate_aggressiveness = init.gimbal_pitch_rate_aggressiveness || this.gimbal_pitch_rate_aggressiveness;
    this.max_gimbal_pitch_rate = init.max_gimbal_pitch_rate || this.max_gimbal_pitch_rate;
    this.gimbal_roll_command = init.gimbal_roll_command || this.gimbal_roll_command;
    this.enforce_lookat_smoothness = init.enforce_lookat_smoothness || this.enforce_lookat_smoothness;
    this.height = init.height || this.height;
    this.height_aggressiveness = init.height_aggressiveness || this.height_aggressiveness;
    this.spatial_waypoints_enable = init.spatial_waypoints_enable || this.spatial_waypoints_enable;
    this.spatial_waypoints_command = init.spatial_waypoints_command || this.spatial_waypoints_command;
    this.override_precision_flight = init.override_precision_flight || this.override_precision_flight;
    this.gimbal_orientation_mode = init.gimbal_orientation_mode || this.gimbal_orientation_mode;
  }
}